document.addEventListener('DOMContentLoaded', function () {
  
  const cards = document.querySelectorAll('.proj-card');
  if (!cards.length) return;

  // Estado de filtros múltiples
  const state = {
    sector: new Set(),
    cat: new Set(),
    pais: new Set()
  };
    function getPlaceholderText(type) {
    const container = document.querySelector('[data-chips="' + type + '"]');
    if (!container) {
      // Fallbacks por si algo falla
      return type === 'cat' ? 'Todas' : 'Todos';
    }

    const fromAttr = container.getAttribute('data-placeholder');
    if (fromAttr && fromAttr.trim() !== '') {
      return fromAttr.trim();
    }

    const span = container.querySelector('.proj-filter-placeholder');
    if (span && span.textContent.trim() !== '') {
      return span.textContent.trim();
    }

    return type === 'cat' ? 'Todas' : 'Todos';
  }


  function normalize(str) {
    return (str || '').toString().trim().toLowerCase();
  }

  function applyFilters() {
    cards.forEach(card => {
      const cs = normalize(card.dataset.sector);
      const cp = normalize(card.dataset.pais);
      const ccList = (card.dataset.cats || '')
        .split(',')
        .map(x => normalize(x));

      const okS = state.sector.size === 0 || state.sector.has(cs);
      const okP = state.pais.size === 0 || state.pais.has(cp);

      let okC = true;
      if (state.cat.size > 0) {
        okC = ccList.some(cat => state.cat.has(cat));
      }

      card.style.display = (okS && okP && okC) ? '' : 'none';
    });
  }

  function renderChips(type) {
    const chipsContainer = document.querySelector('[data-chips="' + type + '"]');
    const block = document.querySelector('.proj-filter[data-filter-type="' + type + '"]');
    if (!chipsContainer || !block) return;

    chipsContainer.innerHTML = '';

    if (state[type].size === 0) {
      const placeholder = document.createElement('span');
      placeholder.className = 'proj-filter-placeholder';
      placeholder.textContent = getPlaceholderText(type);
      chipsContainer.appendChild(placeholder);
      return;
    }


    state[type].forEach(normValue => {
      let selector = '.proj-filter-option[data-value-normalized="' + normValue + '"]';
      if (window.CSS && CSS.escape) {
        selector = '.proj-filter-option[data-value-normalized="' + CSS.escape(normValue) + '"]';
      }
      const opt = block.querySelector(selector);
      const labelText = opt
        ? (opt.querySelector('span')?.textContent.trim() || opt.textContent.trim())
        : normValue;

      const chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'proj-filter-chip';
      chip.dataset.value = normValue;

      const label = document.createElement('span');
      label.textContent = labelText;

      const x = document.createElement('span');
      x.className = 'chip__close';
      x.textContent = '×';

      chip.appendChild(label);
      chip.appendChild(x);

      chip.addEventListener('click', function (event) {
        event.stopPropagation();
        state[type].delete(normValue);

        if (opt) {
          opt.classList.remove('proj-filter-option--selected');
        }

        renderChips(type);
        applyFilters();
      });

      chipsContainer.appendChild(chip);
    });
  }

  const filterBlocks = document.querySelectorAll('.proj-filter');

  filterBlocks.forEach(block => {
    const type = block.getAttribute('data-filter-type');
    if (!type) return;

    const toggleBox = block.querySelector('[data-filter-toggle]');
    const dropdown = block.querySelector('.proj-filter-dropdown');
    if (!toggleBox || !dropdown) return;

    // Guardamos valor normalizado en cada opción
    dropdown.querySelectorAll('.proj-filter-option').forEach(option => {
      const rawValue = option.getAttribute('data-value') || option.textContent.trim();
      option.dataset.valueNormalized = normalize(rawValue);
    });

    // Abrir / cerrar dropdown al clickar en la caja gris
    toggleBox.addEventListener('click', function (event) {
      event.stopPropagation();
      const isOpen = dropdown.classList.contains('is-open');

      // Cerrar todo
      document.querySelectorAll('.proj-filter-dropdown').forEach(dd => dd.classList.remove('is-open'));
      document.querySelectorAll('.proj-filter').forEach(f => f.classList.remove('is-open-filter'));

      if (!isOpen) {
        // Scroll suave hasta la zona de filtros
        // block.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });

        // Calcula cuánto espacio queda desde el bottom del filtro hasta el bottom del viewport
        const rect = toggleBox.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        let available = viewportHeight - rect.bottom - 24; // margen inferior de seguridad

        // Altura mínima razonable
        if (available < 200) available = 200;

        dropdown.style.maxHeight = available + 'px';
        dropdown.scrollTop = 0;

        dropdown.classList.add('is-open');
        block.classList.add('is-open-filter'); // fondo blanco mientras está abierto
      }
    });

    // Click en opciones (multi-select)
    dropdown.querySelectorAll('.proj-filter-option').forEach(option => {
      option.addEventListener('click', function (event) {
        event.stopPropagation();

        const norm = option.dataset.valueNormalized;
        if (!norm) return;

        if (state[type].has(norm)) {
          state[type].delete(norm);
          option.classList.remove('proj-filter-option--selected');
        } else {
          state[type].add(norm);
          option.classList.add('proj-filter-option--selected');
        }

        renderChips(type);
        applyFilters();

        // Cerrar dropdown y quitar estado activo SIEMPRE
        dropdown.classList.remove('is-open');
        block.classList.remove('is-open-filter');
      });
    });
  });
  

  // Cerrar dropdowns al hacer click fuera
  document.addEventListener('click', function () {
    document.querySelectorAll('.proj-filter-dropdown').forEach(dd => dd.classList.remove('is-open'));
    document.querySelectorAll('.proj-filter').forEach(f => f.classList.remove('is-open-filter'));
  });

  ['sector', 'cat', 'pais'].forEach(renderChips);
  applyFilters();
});
